import React from 'react'
import avatarImg from '../../images/practice/4.jpg'

import './style.css'

const listItem = [
    { title: 'Politica y objetivos de calidad V4', file: 'O-GD-003_Politica_y_objetivos_de_calidad_V4.pdf' },
    { title: 'Politica y objetivos de SST V8', file: 'O-GD-004 Politica y objetivos de SST V8.pdf' },
    { title: 'Politica no drogas, alcohol y tabaco V7', file: 'O-GD-009 Politica no drogas, alcohol y tabaco V7.pdf' },
    { title: 'Politica Acoso laboral, sexual, violencia V4', file: 'O-GD-010 Politica Acoso laboral, sexual, violencia V4.pdf' },
    { title: 'Politica de desconexion laboral V4', file: 'O-GD-011 Política de desconexión laboral v4.pdf' },
    { title: 'Reglamento de Higiene y Seguridad Industrial V5', file: 'O-HSQ-003 Reglamento de Higiene y Seguridad Industrial V5.pdf' },
    { title: 'Politica de Seguridad y Privacidad de la Informacion 2026', file: 'POLITICAS DE SEGURIDAD Y PRIVACIDAD DE LA INFORMACION RODRIGUEZ Y CORREA ABOGADOS-2026.pdf' },
    { title: 'Politica de Tratamiento de Datos 2026', file: 'POLITICA DE TRATAMIENTO DE DATOS 2026.pdf' },
]

const docHref = (file) => `docs/${encodeURIComponent(file).replace(/%2F/g, '/')}`

const SingleContentArea = ({ className, avatar, image }) => {
    return (
        <div className={className}>
            <div className="singleContentWrap">
                <h3>Conoce nuestras políticas y protocolos internos</h3>
                <p>Contamos con certificacionces ISO, por tanto es importante para nosotros contar con diferentes tipos de políticas y protocolos</p>
                {avatar && (
                    <div className="avatarWra">
                        <div className="row">
                            <div className="col-md-4">
                                <img src={avatarImg} alt="" />
                            </div>
                            <div className="col-md-8">
                                <h4>Políticas y Protocolos</h4>
                                <ul>
                                    {listItem.map(list => (
                                        <li key={list.title}>
                                            <a href={docHref(list.file)} target="_blank" rel="noopener noreferrer">
                                                {list.title}
                                            </a>
                                        </li>
                                    ))}

                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
export default SingleContentArea